import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { deepCopy } from "@/utils/jsonUtils";

export interface FlightStatusState {
  flightStatusData: any[];
  filters: string[];
  favoriteFlights: any[];
  flightStatusTitle: string;
  flightStatusTitleCard: string,
  origin: any;
  destination: any;
  departureDate: string;
  flightNumber: string;
  pnr: string;
  lastName: string;
  count: number;
}

const initialStateOfFlightStatus: FlightStatusState = {
  flightStatusData: [],
  filters: [],
  favoriteFlights: [],
  flightStatusTitle: "",
  flightStatusTitleCard: "",
  origin: "",
  destination: "",
  departureDate: "",
  flightNumber: "",
  pnr: "",
  lastName: "",
  count: 0
};

export const flightStatusSlice = createSlice({
  name: "flightStatus",
  initialState: initialStateOfFlightStatus,
  reducers: {
    setFlightStatusData: (state, action: PayloadAction<string[]>) => {
      // eslint-disable-next-line no-param-reassign
      state.flightStatusData = action.payload;
    },
    pushIntoFilter: (state, action: PayloadAction<string>) => {
      const tempFilters = deepCopy(state.filters);
      tempFilters.push(action.payload);
      // eslint-disable-next-line no-param-reassign
      state.filters = tempFilters;
    },
    setFilters: (state, action: PayloadAction<string[]>) => {
      const tempFilters = action.payload;
      // eslint-disable-next-line no-param-reassign
      state.filters = tempFilters;
    },
    setFavoriteFlights: (state, action: PayloadAction<string[]>) => {
      // eslint-disable-next-line no-param-reassign
      state.favoriteFlights = action.payload;
    },
    setFlightStatusTitle: (state, action: PayloadAction<string>) => {
      // eslint-disable-next-line no-param-reassign
      state.flightStatusTitle = action.payload;
    },
    setFlightStatusTitleCard: (state, action: PayloadAction<string>) => {
      // eslint-disable-next-line no-param-reassign
      state.flightStatusTitleCard = action.payload;
    },
    setOrigin: (state, action: PayloadAction<any>) => {
      // eslint-disable-next-line no-param-reassign
      state.origin = action.payload;
    },
    setDestination: (state, action: PayloadAction<string>) => {
      // eslint-disable-next-line no-param-reassign
      state.destination = action.payload;
    },
    setDepartureDate: (state, action: PayloadAction<string>) => {
      // eslint-disable-next-line no-param-reassign
      state.departureDate = action.payload;
    },
    setFlightNumber: (state, action: PayloadAction<string>) => {
      // eslint-disable-next-line no-param-reassign
      state.flightNumber = action.payload;
    },
    setPnr: (state, action: PayloadAction<string>) => {
      // eslint-disable-next-line no-param-reassign
      state.pnr = action.payload;
    },
    setLastName: (state, action: PayloadAction<string>) => {
      // eslint-disable-next-line no-param-reassign
      state.lastName = action.payload;
    },
    setCount: (state, action: PayloadAction<number>) => {
      // eslint-disable-next-line no-param-reassign
      state.count = action.payload;
    }
  }
});

export const {
  setFlightStatusData,
  pushIntoFilter,
  setFilters,
  setFavoriteFlights,
  setFlightStatusTitle,
  setOrigin,
  setDestination,
  setDepartureDate,
  setFlightNumber,
  setPnr,
  setLastName,
  setFlightStatusTitleCard,
  setCount
} = flightStatusSlice.actions;

export default flightStatusSlice.reducer;
